import InsertLinkIcon from '@mui/icons-material/InsertLink'
import AbcIcon from '@mui/icons-material/Abc'
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from '@mui/material'
import { ReactElement, useState } from 'react'
import DialogConfirm from './Dialog'

interface State {
  title: string
  url: string
  target: '_blank' | '_self'
}
interface Props {
  open: boolean
  handleClose: () => void
  handleSubmit: (props: State) => void
}
export default function InsertLink({
  open,
  handleClose,
  handleSubmit,
}: Props): ReactElement {
  const [state, setState] = useState<State>({
    title: '',
    url: '',
    target: '_self',
  })
  const onSubmit = async () => {
    if (state.url && state.title) handleSubmit(state)
  }
  return (
    <DialogConfirm
      disabled={!state.url || !state.title}
      open={open}
      handleClose={handleClose}
      handleSubmit={onSubmit}
      maxWidth="sm"
      title={'リンクの追加'}
      primaryButtonColor="secondary"
      primaryButtonText="決定する"
    >
      <Stack>
        <Typography>表示テキスト</Typography>
        <TextField
          required
          label=""
          margin="dense"
          size="small"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <AbcIcon />
              </InputAdornment>
            ),
          }}
          name="text"
          variant="standard"
          value={state.title}
          onChange={(e) => {
            setState({
              ...state,
              title: e.target.value,
            })
          }}
        />
      </Stack>
      <Stack
        direction="row"
        alignItems="center"
        sx={{
          maxHeight: '70vh',
          minHeight: 100,
        }}
      >
        <Stack flex={1}>
          <Typography>リンクURL</Typography>
          <TextField
            required
            label=""
            margin="dense"
            size="small"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <InsertLinkIcon />
                </InputAdornment>
              ),
            }}
            name="url"
            variant="standard"
            value={state.url}
            onChange={(e) => {
              setState({
                ...state,
                url: e.target.value,
              })
            }}
          />
        </Stack>
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                checked={state.target === '_blank'}
                onChange={() => setState({ ...state, target: '_blank' })}
              />
            }
            label="別のタブで開く"
          />
        </FormGroup>
      </Stack>
    </DialogConfirm>
  )
}
